import {
  SET_MEMBERSHIP,
  LOADING_END,
  LOADING_START,
} from "../actions/Membership/types";
const initialState = {
  isLoading: false,
  subscribedPlan: {},
  error: null,
};

const membershipReducer = (state = initialState, { type, payload }) => {
  switch (type) {
    case SET_MEMBERSHIP:
      return { ...state, subscribedPlan: payload };
    case LOADING_START:
      return { ...state, isLoading: true };
    case LOADING_END:
      return { ...state, isLoading: false };
    default:
      return state;
  }
};
export default membershipReducer;
